module.exports = __webpack_public_path__ + "img/button_rule.51c49d1f.png";